// extracted by mini-css-extract-plugin
export var gif = "_cr-0";